/**
 * De quem é a carteira na tela, e qual VISÃO o usuário está olhando.
 *
 * O Consolidador tinha esta pergunta espalhada: cada view olhava `id_cliente` direto. Quando o
 * grupo familiar virou um contexto de Carteiras (AZ-b449ba53), toda tela que perguntava assim
 * respondia errado com uma família ativa e nenhum cliente — caía no empty state
 * "Você não possui nenhum cliente selecionado" com a família escolhida na tela.
 *
 * ★★★ Quem manda é a SELEÇÃO, não o toggle. Trocar `Clientes`/`Leads`/`Famílias` com um grupo já
 * escolhido NÃO pode mudar a tela — o usuário só trocou a lista onde vai procurar, ainda não
 * selecionou outra coisa. Mudar ali fazia o alerta, o card e o conteúdo do cliente reaparecerem
 * por cima da carteira do grupo, e as ações ofereciam "Editar grupo familiar" sem grupo nenhum.
 *
 *   - `tipo`     = de quem é a carteira que está na tela AGORA ('grupo' | 'cliente' | null)
 *   - `viewTipo` = o mesmo `tipo` enquanto houver seleção; SÓ com a tela vazia é que ele cai no
 *                  modo do toggle, porque aí não há outro sinal do que o usuário quer ver
 *
 * É função pura sobre os getters, e não mixin: são poucos consumidores, e um `computed` que chama
 * `resolveWalletScope` deixa visível de onde o valor vem — o mixin escondia isso.
 */

import store from '@state/store'

/**
 * @param {Object} params
 * @param {Number|String} params.idCliente cliente selecionado na tela
 * @returns {Object} `{ ativo, tipo, grupo, viewTipo, viewSemSelecao }`
 */
export const resolveWalletScope = ({ idCliente } = {}) => {
  const grupo = store.getters['consolidator/currentFamilyGroup'] || null
  const viewTipo = store.getters['consolidator/isFamilyGroupView']
    ? 'grupo'
    : 'cliente'

  const tipo = grupo ? 'grupo' : resolveClientScope(idCliente)
  const ativo = tipo !== null

  return {
    ativo,
    tipo,
    grupo,
    viewTipo: ativo ? tipo : viewTipo,
    viewSemSelecao: !ativo,
  }
}

const resolveClientScope = (idCliente) => {
  if (typeof idCliente === 'string') return idCliente === '' ? null : 'cliente'
  return idCliente > 0 ? 'cliente' : null
}
